// base-crud.service.ts
import { BreadService, BreadFilter, BreadOptions, Paginated } from './bread.service';

export abstract class BaseCrudService<T> {
  protected abstract model: string;
  constructor(protected bread: BreadService) {}

  all(opts?: BreadOptions) {
    return this.bread.all<T>(this.model, opts);
  }
  list(page = 1, perPage = 10, opts?: BreadOptions) {
    return this.bread.list<T>(this.model, page, perPage, opts);
  }
  find(id: number | string, opts?: BreadOptions) {
    return this.bread.find<T>(this.model, id, opts);
  }
  findBy<K extends keyof T & string>(prop: K, value: T[K], opts?: BreadOptions) {
    return this.bread.findBy<T>(this.model, prop, value, opts);
  }
  filterBy(filters: BreadFilter, opts?: BreadOptions) {
    return this.bread.filterBy<T>(this.model, filters, opts);
  }
  add(data: Partial<T>, opts?: BreadOptions) {
    return this.bread.add<T>(this.model, data, opts);
  }
  edit(id: number | string, data: Partial<T>, opts?: BreadOptions) {
    return this.bread.edit<T>(this.model, id, data, opts);
  }
  /** Met à jour par une clé (ex: name) au lieu de l'id. */
  update(keyName: string, keyValue: string | number, data: Partial<T>, opts?: BreadOptions) {
    return this.bread.update<T>(this.model, keyName, keyValue, data, opts);
  }
  delete(data: any, opts?: BreadOptions) {
    return this.bread.delete<T>(this.model, data, opts);
  }
  patch(id?: number | string | undefined, data?: Partial<T>, opts?: BreadOptions) {
    return this.bread.patch<T>(this.model, id ?? undefined, data ?? {} as any, opts);
  }
}
